import { createFileRoute } from '@tanstack/react-router'
import { UploadDocumentoPage } from '@/features/upload-documento'
import { requireAtestadosAccess } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/novo-documento/')({
  beforeLoad: async () => {
    await requireAtestadosAccess()
  },
  component: UploadDocumentoPage,
})
